import { Button } from 'components/Button';
import { Modal } from 'components/Modal';

import * as S from './DetailsModal.styles';
import { shouldShow } from './utils';

interface Props {
  details: any;
  onClose: () => void;
}

export const DetailsModal: React.FC<Props> = ({ details, onClose }) => {
  const formattedDetails = Object.entries(details.original).map(([key, value]) => ({
    key,
    value,
  }));

  return (
    <Modal>
      <S.modalWrapper>
        <Button motive="m4" onClick={onClose} iconLeft="FiArrowLeft">
          Close
        </Button>
        <S.list>{formattedDetails.map((item) => shouldShow(item))}</S.list>
      </S.modalWrapper>
    </Modal>
  );
};
